import { useHistory, useLocation } from 'react-router-dom';
import type { INavLink, INavLinkGroup } from '@m365-admin/nav';

import { useFeature, usePermission, useRole } from './Hooks/useFeature';

export const useNavConfig = () => {
    const history = useHistory();
    const location = useLocation();

    // Each nav link is gated on a capability key from the resolved feature tree.
    const canDashboard = useFeature('page.hrcDashboard').enabled;
    const canCrm = useFeature('page.crmCases').enabled;
    // Email Templates is an Admin-only surface: gate it on the same permission the API enforces
    // (only the Admin role is seeded with Email.ManageTemplates), so HRC/Manager never see it.
    const canEmailTemplates = usePermission('Email.ManageTemplates');
    // Managers see the dashboard nav labeled "My Dashboard" (matches the page title); others see "HRC Dashboard".
    const isManager = useRole() === 'Manager';

    const securityNavConfig: INavLinkGroup[] = [];

    const pbtLinks: INavLink[] = [
        canDashboard && {
            key: '100',
            name: isManager ? 'My Dashboard' : 'HRC Dashboard',
            icon: 'ViewDashboard',
            url: '',
            onClick: () => history.push('/PBT/Dashboard'),
            isSelected: location?.pathname === '/PBT/Dashboard',
        },
        canCrm && {
            key: '101',
            name: 'CRM Cases',
            icon: 'CRMCustomerInsightsApp',
            url: '',
            onClick: () => history.push('/PBT/CRMCases'),
            isSelected: location?.pathname === '/PBT/CRMCases',
        },
        canEmailTemplates && {
            key: '102',
            name: 'Email Templates',
            icon: 'EmailIcon',
            url: '',
            onClick: () => history.push('/email-templates'),
            isSelected: location?.pathname === '/email-templates',
        },
    ].filter(Boolean) as INavLink[];

    const pbtNavConfig: INavLinkGroup[] =
        pbtLinks.length > 0 ? [{ key: 'PBT', name: '', links: pbtLinks }] : [];

    return {
        securityNavConfig,
        pbtNavConfig,
    };
};
